import React from 'react'
import moment from 'moment-timezone'
import { Table, Row, Card, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'

import Forcast from './Forcast'

export default class WeatherCard extends React.Component {
  constructor (props) {
    super(props)
    this.props = props
    this.state = {}
  }

  render () {
    return (
      <Card className='mb-3'>
        <Card.Body>
          <Card.Title>
            <div className='float-end'><sup>Last Updated: {moment(this.props.area.current.time).format('h:mm a')}</sup></div>
            {this.props.area.name}
          </Card.Title>
          <hr />
          <Table borderless className='mb-2'>
            <tbody>
              <tr style={{ verticalAlign: 'middle' }}>
                <td className='text-start' style={{ fontSize: '3em' }}>{this.props.area.current.precipitation.value > 0 ? this.props.area.current.precipitation.emoji : this.props.area.current.cloud_cover.emoji}</td>
                <td className='text-center' style={{ fontSize: '2em' }}>{this.props.area.current.precipitation.value > 0 ? this.props.area.current.precipitation.description : this.props.area.current.cloud_cover.description}</td>
                <td className='text-end' style={{ fontSize: '3em' }}>{this.props.area.current.precipitation.value > 0 ? this.props.area.current.precipitation.emoji : this.props.area.current.cloud_cover.emoji}</td>
              </tr>
            </tbody>
          </Table>
          <Row className='row-cols-3 mb-2 text-center'>
            <Col>
              <OverlayTrigger placement='bottom' overlay={<Tooltip>Temperature</Tooltip>}>
                <span>🌡️ {this.props.area.current.temperature_2m}{this.props.area.current_units.temperature_2m}</span>
              </OverlayTrigger>
            </Col>
            <Col>
              <OverlayTrigger placement='bottom' overlay={<Tooltip>Gusts</Tooltip>}>
                <span>💨 {this.props.area.current.wind_gusts_10m} {this.props.area.current_units.wind_gusts_10m}</span>
              </OverlayTrigger>
            </Col>
            <Col>
              <OverlayTrigger placement='bottom' overlay={<Tooltip>Wind Direction</Tooltip>}>
                <span>🧭 {this._transformDirection(this.props.area.current.wind_direction_10m)} {this.props.area.current.wind_direction_10m}{this.props.area.current_units.wind_direction_10m}</span>
              </OverlayTrigger>
            </Col>
          </Row>
          <hr />
          <Forcast _transformDirection={this._transformDirection} area={this.props.area} />
        </Card.Body>
      </Card>
    )
  }

  _transformDirection (deg) {
    if (deg >= 22.5 && deg < 67.5) return 'NE'
    if (deg >= 67.5 && deg < 112.5) return 'E'
    if (deg >= 112.5 && deg < 157.5) return 'SE'
    if (deg >= 157.5 && deg < 202.5) return 'S'
    if (deg >= 202.5 && deg < 247.5) return 'SW'
    if (deg >= 247.5 && deg < 292.5) return 'W'
    if (deg >= 292.5 && deg < 337.5) return 'NW'
    return 'N'
  }
}
